import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class ServiceListItemContent extends Component {
  render() {
    var checked = this.props.checked;

    let className = cx({
      serviceListItemContent: true,
      checked: checked,
    });

    return (
      <div className={classnames(className)}>
        <div className="container">{this.props.children}</div>
      </div>
    );
  }
}
